if (!customElements.get('ember-sticky-purchase')) {
  customElements.define('ember-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = document.querySelector('.product--mug3')?.closest('product-info');
      this.sourceButton = this.productInfo?.querySelector('product-form button[type="submit"]');
      if (!this.sourceButton) return;
      this.button = this.querySelector('[data-purchase-button]');
      this.label = this.querySelector('[data-purchase-label]');
      this.price = this.querySelector('[data-purchase-price]');
      this.variant = this.querySelector('[data-purchase-variant]');
      this.error = this.querySelector('[data-purchase-error]');
      this.mobile = matchMedia('(max-width: 749px)');
      this.updateVisibility = () => {
        const visible = !this.previewMenuOpen && (this.mobile.matches || !this.mainButtonVisible);
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
      };
      this.observer = new IntersectionObserver(([entry]) => {
        this.mainButtonVisible = entry.isIntersecting;
        this.updateVisibility();
      });
      this.observer.observe(this.sourceButton);
      this.mobile.addEventListener('change', this.updateVisibility);
      this.onClick = () => {
        this.sync();
        if (this.button.disabled) return;
        if (this.restock) {
          this.restock.querySelector('details').open = true;
          this.restock.scrollIntoView({ block: 'center' });
          this.restock.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        } else {
          this.sourceButton.click();
        }
      };
      this.button.addEventListener('click', this.onClick);
      // Reuse the native form, including quantity, cart drawer, loading and errors.
      this.stateObserver = new MutationObserver(() => this.sync());
      this.stateObserver.observe(this.productInfo, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'aria-checked', 'hidden', 'class']
      });
      // Shopify's preview UI lives in the top layer and can cover fixed CTAs.
      // Measure its visible wrapper, not its full-viewport transparent iframe.
      this.updatePreviewPosition = () => {
        const rect = this.previewWrapper?.getBoundingClientRect();
        this.previewMenuOpen = !!rect && rect.height > window.innerHeight * 0.4;
        if (!this.previewMenuOpen) {
          const offset = rect?.height > 0 ? Math.max(0, window.innerHeight - rect.top) : 0;
          document.documentElement.style.setProperty('--ember-preview-offset', `${Math.ceil(offset)}px`);
        }
        this.updateVisibility();
      };
      this.previewResizeObserver = new ResizeObserver(this.updatePreviewPosition);
      this.attachPreview = () => {
        const wrapper = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
        if (wrapper !== this.previewWrapper) {
          this.previewResizeObserver.disconnect();
          this.previewWrapper?.removeEventListener('toggle', this.updatePreviewPosition);
          this.previewWrapper = wrapper;
          if (wrapper) {
            this.previewResizeObserver.observe(wrapper);
            wrapper.addEventListener('toggle', this.updatePreviewPosition);
          }
        }
        this.updatePreviewPosition();
      };
      this.previewInsertionObserver = new MutationObserver(this.attachPreview);
      this.previewInsertionObserver.observe(document.body, { childList: true });
      window.addEventListener('resize', this.updatePreviewPosition);
      this.attachPreview();
      this.sync();
      this.updateVisibility();
    }

    sync() {
      const changing = this.productInfo.getAttribute('aria-busy') === 'true';
      const loading = this.sourceButton.classList.contains('loading');
      this.restock = changing ? null : this.productInfo.querySelector('ember-restock:not([hidden])');
      const visibilityTarget = this.restock?.querySelector('summary') || this.sourceButton;
      if (this.visibilityTarget !== visibilityTarget) {
        this.observer.disconnect();
        this.observer.observe(visibilityTarget);
        this.visibilityTarget = visibilityTarget;
      }
      this.button.disabled = changing || (!this.restock && (this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true'));
      this.price.hidden = !!this.restock;
      this.price.previousElementSibling.hidden = !!this.restock;
      this.button.setAttribute('aria-busy', String(loading || changing));
      this.label.textContent = changing ? 'Updating' : this.restock ? 'Notify me when available' : loading ? 'Adding' : this.sourceButton.querySelector('span')?.textContent.trim() || 'Add to cart';
      const swatch = this.productInfo.querySelector('[data-ember-color-swatch][aria-checked="true"]');
      if (swatch?.dataset.variantPrice) this.price.textContent = swatch.dataset.variantPrice;
      const selected = this.productInfo.querySelector('[data-ember-selected-variant]');
      if (selected && !changing) {
        try { this.variant.textContent = JSON.parse(selected.textContent).title; } catch (_) { /* Keep the last valid selection. */ }
      }
      const sourceError = this.productInfo.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      const message = sourceError?.textContent.trim() || '';
      if (this.error.textContent !== message) this.error.textContent = message;
      this.error.hidden = !message;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.stateObserver?.disconnect();
      this.mobile?.removeEventListener('change', this.updateVisibility);
      this.button?.removeEventListener('click', this.onClick);
      this.previewResizeObserver?.disconnect();
      this.previewInsertionObserver?.disconnect();
      this.previewWrapper?.removeEventListener('toggle', this.updatePreviewPosition);
      window.removeEventListener('resize', this.updatePreviewPosition);
      document.documentElement.style.removeProperty('--ember-preview-offset');
    }
  });
}
